<template>
    <div  style="background: #fff!important;overflow: hidden;padding:36px 0;"  class="fullWdth">
      <div class="controlWdth">
        <div class="common_search">
          <div class="common_nav_center">
            <div class="common_nav_center_top">
              <div class="common_nav_log float-left" >
                <router-link to="/" >
                  <img :src='logourl' onerror="src='/static/img/logo.png'" style="max-width:200px;max-height:60px;width: auto;" />
                </router-link>
              </div>
              <div class="common_nav_search float-left">
                <i class="layui-icon iconfont iconfangdajing theme-bg" @click="onSearch" style="font-size: 16px;position: absolute;right: 0;margin-top: 4px;margin-right: 4px;width: 34px;line-height: 34px;height: 34px;"></i>
                <input @keyup.enter="onSearch" v-model="search_keywords" type="text" id="search"  class="" placeholder="搜索您想要的商品"/>
                <!-- <button @click="onSearch" class="theme-bg theme-bd common_nav_search_btn">搜索</button> -->
              </div>
              <div class="common_nav_cat float-left" @click="cart()" style="cursor: pointer;">
                  <div class='cart-icon float-left'>
                      <i class="iconfont iconduihuandai theme-col"></i>
                  </div>
                  <div class="cart">
                      {{ $common.cardName().name }} <span class="theme-col" >{{$store.state.cartnum}}</span> 件
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            search_keywords:'',
            logourl:this.$store.state.webInfo.logo_pc,
        }
    },
    methods:{
      cart(){
        this.$router.push({ name: "Cart" });
      },
      onSearch(){
        this.$router.push({name:'Goodslist',query: {keyword: this.search_keywords}})
      }
    },
    mounted () {
    },
}
</script>
<style lang="less">
    // .fullWdth{
    //   min-width: 1190px!;
    // }
    .el-main{
        padding: 0!important;
    }
    .common_search{
        // padding-top: 20px;
    }
    .common_nav_search{
    margin-left: 81px;
    position: relative;
  }
  #search:focus{
    border-color:#F83132;
  }
  .common_nav_search .hot{
    padding-left: 0px;
    margin-top: 5px;
  }
  .common_nav_search input{
    width: 670px;
    height: 38px;
    padding-left: 15px;
    float: left;
    border: 1px solid #e7e7e7;
    font-size: 14px;
    line-height: 38px;
  }
  .common_nav_search_btn{
    width: 118px;
    height: 40px;
    font-size: 18px;
    font-weight: bold;
  }
  .common_nav_cat{
    margin-left: 75px;
    height: 40px;
    width: 143px;
    background:rgba(255,255,255,1);
    border:1px solid rgba(230,231,231,1);
    .cart-icon{
      padding:10px 15px ;
    }
    .cart-icon img{
      vertical-align:initial;
    }
    .cart{
      float:left;
      padding-left:10px;
      position:relative;
      line-height:42px;
      color:#979797;
      span{
        font-size:16px;
        font-weight:bold;
      }
    }
    .cart:before{
        content: "";
        display:inline-block;
        width: 1px;
        height:12px;
        background:#D8D8D8;
        position:absolute;
        left:0px;
        top:16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/common/search.vue